import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

const agent = axios.create({
  baseURL: API_URL,
  // headers: {
  //   'Content-Type': 'application/json',
  // },
  withCredentials: false, // change to true only if you're using cookies/sessions
})

// ✅ Request Interceptor
agent.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem('token'))
    const gameId = localStorage.getItem('gameId') ?? 1

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    config.headers['x-game-info'] = `${gameId}`

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// ✅ Response Interceptor
agent.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error

    if (response && response.status === 401) {
      localStorage.clear()
      window.location.href = '/login'
    }

    return Promise.reject(response?.data || error)
  },
)

export { agent }
